import {Button, NotificationCount} from './BurgerButton.styled';
import Burger from '@assets/svg/bars.svg';
import {useStore} from '@store/appStore';
import {memo, useState} from 'react';

interface IProps{
  isSettings:boolean;
}

export const BurgerButton = (props:IProps) => {
  const [isHovering, setisHovering] = useState(false);
  const { menuOpen, setMenuOpen,notificationCounter } = useStore();

  return (
    <Button isSettings={props.isSettings} onClick={() => setMenuOpen(!menuOpen)} onMouseEnter={() => setisHovering(true)} onMouseLeave={() => setisHovering(false)}>
      {//notificationCounter > 0?<NotificationCount>{notificationCounter}</NotificationCount>:null
      }
      <Burger />
    </Button>
  );
};

export default memo(BurgerButton);
